import { render, staticRenderFns } from "./FazerPedido.vue?vue&type=template&id=7777b2c6&scoped=true&"
import script from "./FazerPedido.vue?vue&type=script&lang=js&"
export * from "./FazerPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7777b2c6",
  null
  
)

export default component.exports